import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from "formik";
import { Box, Button, Container, makeStyles, TextField, Typography, } from "@material-ui/core";
import { useMaster } from "../Provider/Master";
import { useLoginMutation } from "../Generated/graphql";
const useStyles = makeStyles((theme) => ({
    root: {
        height: "100%",
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3),
    },
}));
export const Login = () => {
    const classes = useStyles();
    const { setJwtPersistant } = useMaster();
    const [login, { loading }] = useLoginMutation({
        onCompleted(returnValue) {
            setJwtPersistant(returnValue === null || returnValue === void 0 ? void 0 : returnValue.login);
        },
    });
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        onSubmit: (input) => {
            login({ variables: { input } });
        },
    });
    return (_jsx(Box, Object.assign({ className: classes.root }, { children: _jsx(Container, Object.assign({ maxWidth: "sm" }, { children: _jsxs("form", Object.assign({ onSubmit: formik.handleSubmit }, { children: [_jsx(Box, Object.assign({ mt: 3, mb: 1 }, { children: _jsx(Typography, Object.assign({ align: "center", color: "textPrimary", variant: "h2" }, { children: "Se connecter" }), void 0) }), void 0),
                    _jsx(TextField, { id: "email", name: "email", onChange: formik.handleChange, value: formik.values.email, helperText: formik.errors.email, error: formik.errors.email !== undefined, label: "Email", type: "string", variant: "outlined", margin: "normal", fullWidth: true }, void 0),
                    _jsx(TextField, { id: "password", name: "password", onChange: formik.handleChange, value: formik.values.password, helperText: formik.errors.password, error: formik.errors.password !== undefined, label: "Mot de passe", type: "password", variant: "outlined", margin: "normal", fullWidth: true }, void 0),
                    _jsx(Box, Object.assign({ my: 2 }, { children: _jsx(Button, Object.assign({ color: "primary", disabled: loading, fullWidth: true, size: "large", type: "submit", variant: "contained" }, { children: "Se connecter" }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=Login.js.map